/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyEmailContact
 */
export interface EmergencyEmailContact {
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContact
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContact
     */
    language_code: string;
}

/**
 * Check if a given object implements the EmergencyEmailContact interface.
 */
export function instanceOfEmergencyEmailContact(value: object): value is EmergencyEmailContact {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function EmergencyEmailContactFromJSON(json: any): EmergencyEmailContact {
    return EmergencyEmailContactFromJSONTyped(json, false);
}

export function EmergencyEmailContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyEmailContact {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'language_code': json['language_code'],
    };
}

export function EmergencyEmailContactToJSON(json: any): EmergencyEmailContact {
    return EmergencyEmailContactToJSONTyped(json, false);
}

export function EmergencyEmailContactToJSONTyped(value?: EmergencyEmailContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'language_code': value['language_code'],
    };
}

